import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ApiModelService} from "../sp-api-model/api-model.service";
import {Company} from "../../../models/company";
import {User} from '../../../models/user';
import {Role} from '../../../models/role';
import {LoggerService} from '../../sp-logger/logger.service';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiCompanyService extends ApiModelService<Company> {
  protected readonly basePath = "companies";

  constructor(httpClient: HttpClient, logger: LoggerService) {
    super(httpClient, logger);
  }

  /* Other methods with relations go here */

  addUser(company: Company, user: User, role: Role): Promise<Company> {
    return firstValueFrom(this.post<Company>(`companies/${company.id}/users/${user.id}`, {role_id: role.id}));
  }

  deleteUser(company: Company, user: User): Promise<Company> {
    return firstValueFrom(this.delete<Company>(`${this.basePath}/${company.id}/users/${user.id}`));
  }

  inviteUserOAuth(company: Company, user: User): Promise<User> {
    return firstValueFrom(this.post<User>(`companies/${company.id}/user/inviteOAuth`, user));
  }

  linkAgency(company: Company, agency: Company): Promise<void> {
    return firstValueFrom(this.post<void>(`companies/${company.id}/agency/${agency.id}`));
  }

  unlinkAgency(company: Company, agency: Company): Promise<void> {
    return firstValueFrom(this.delete<void>(`companies/${company.id}/agency/${agency.id}`));
  }

  getManagedCompanies(company: Company): Promise<Company[]> {
    return firstValueFrom(this.get<Company[]>(`companies/${company.id}/managed`));
  }

  /* ------------------------------------ */
}
